module.exports = __webpack_public_path__ + "static/media/Roboto-Thin.bb90fb91.ttf";